/* eslint-disable camelcase */
import React from 'react';
import CustomStepper from 'src/common/refactoredComponents/progressBar/CustomStepper';
import { StepperContainer } from 'src/common/refactoredComponents/progressBar/StepProgressBar.styled';
import ReportUsageProgressStepCompleted from 'src/assets/images/ReportUsageProgressStepCompleted.svg';
import ReportUsageProgressStepCurrent from 'src/assets/images/ReportUsageProgressStepCurrent.svg';
import withStyles from '@material-ui/core/styles/withStyles';
import Card from 'src/common/refactoredComponents/card/Card';
import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import { sizes } from 'src/styles/Media.styled';
import { useSelector } from 'react-redux';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const customStepperStyle = {
    stepper: {
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'space-around',
        padding: 0,
        width: '100%',
    },

    stepper__step: {
        position: 'relative',
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: '100%',
    },

    stepper__step__index: {
        width: '20px',
        height: '20px',
        lineHeight: '3px',
        borderRadius: '50%',
        background: '#989898 0% 0% no-repeat padding-box',
        border: '1px solid #FFFFFF',
        textAlign: 'center',
        marginBottom: '5px',
    },

    stepper__step__index_not_completed: {
        width: '10px',
        height: '10px',
    },

    stepper__step_index_completed: {
        backgroundImage: `url(${ReportUsageProgressStepCompleted})`,
    },
    stepper__step__label: {
        letterSpacing: '0px',
        color: 'var(--label-color)',
        opacity: 1,
        margin: '-4px',
        fontFamily: 'AvenirNextWorld Demi',
        fontSize: '14px',
        lineHeight: '24px',
        position: 'absolute',
        bottom: '-20px',
    },

    labelContainer: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'center',
    },

    // gap between line and dots
    linearProgress: {
        flex: '1 1 auto',
        position: 'absolute',
        top: 9,
        left: 'calc(-50% + 5px)',
        right: 'calc(50% + 5px)',
        backgroundColor: '#989898 0% 0% no-repeat padding-box',
    },

    linearProgressInitial: {
        flex: '1 1 auto',
        position: 'absolute',
        top: 7,
        left: 'calc(-50% + 5px)',
        right: 'calc(50% + 5px)',
        backgroundColor: '#989898 0% 0% no-repeat padding-box',
    },

    bar: {
        backgroundColor: '#C529BB',
    },

    currentStep: {
        backgroundColor: 'white',
        color: '#fff',
        fontWeight: '500',
        width: '16px',
        height: '16px',
        borderRadius: '50%',
        backgroundImage: `url(${ReportUsageProgressStepCurrent})`,
    },

    done: {
        // backgroundColor: '#1DB2B2 !important',
        color: '#fff',
        fontWeight: '500',
    },

    title: {
        display: 'flex',
        flexGrow: '1',
        alignSelf: 'baseline',
        alignItems: 'flex-end',
        height: '50%',
    },
    imageContainer: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: '1',
        height: '50%',
    },
};

export const ContainerDiv = styled.div`
    width: 100%;
    padding: 5px 0 0 0;
    // margin-bottom : 1.5rem;
    ${media.mobileDevice`
        background-color: #f5f5f5;
        // padding-left:15px;
        // padding-right:15px;
    `}
`;

function StepProgressBar({
    classes,
    progressBarSteps,
    progressBarIconClickHandler,
    procedurePageVisibility,
    replenishmentPageVisibilityUsage,
    countryCode,
}) {
    const winWidth = window.innerWidth;
    const isDesktopView = winWidth >= sizes.mediumDevice;
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    useEffectWithErrorLogging(() => {
        document.documentElement.style.setProperty(
            '--label-color',
            isCondensedView ? '#3c3c3c' : '#707070'
        );
    }, [isCondensedView]);
    !procedurePageVisibility ? delete progressBarSteps.Procedure : null;
    !replenishmentPageVisibilityUsage ? delete progressBarSteps.Replen : null;
    return (
        <ContainerDiv>
            <Card 
            backgroundColor = {isCondensedView ? 'none' : '#fff'}
            boxShadow = {isCondensedView ? 'none' : ' 0px 0px 6px #00000029'}
            >
                <StepperContainer
                    ipadPaddingRight={'0px'}
                    ipadPaddingLeft={'0px'}
                    marginRight={'-30px'}
                    marginLeft={'-30px'}
                    mbMarginRight={'0px'}
                    mbMarginLeft={'0px'}
                    mbPadding={'9px 0px'}
                    marginLeftDesk={isCondensedView}
                    marginRightDesk={isCondensedView}
                    height={isCondensedView && isDesktopView && '100%'}
                >
                    <CustomStepper
                        classes={classes}
                        steps={progressBarSteps}
                        handleClick={progressBarIconClickHandler}
                    />
                </StepperContainer>
            </Card>
        </ContainerDiv>
    );
}

export default withStyles(customStepperStyle)(StepProgressBar);
